import React from 'react';

import { Button } from '@bestdoctor/spectrum-uikit/Button';
import { ReactComponent as DownloadIconComponent } from '../../pages/Documents/download.svg';

import { useGetExpendituresToExcel } from 'hooks/finance/useGetExpendituresToExcel';

import { useSnackbar } from 'notistack';
import { ActionWithFinanceBtnProps } from 'interfaces/finance/financeInterfaces';
import { ErrorData } from 'interfaces/global/globalInterfaces';

export const ActionWithFinanceBtn: React.FC<ActionWithFinanceBtnProps> = ({ isFronting, selectedPeriodByFinance }) => {
  const { enqueueSnackbar } = useSnackbar();

  const periodId = selectedPeriodByFinance ? selectedPeriodByFinance.uuid : null;

  const { refetchExportExpendituresToExcel } = useGetExpendituresToExcel({
    servicePeriodUuid: periodId,
    onSuccess: () => {
      enqueueSnackbar('Файл был сформирован и отправлен на ваш E-mail', { variant: 'success' });
    },
    onError: (res) => {
      if (res.response.status >= 400 && res.response.status < 500) {
        res.response.json().then((result) => {
          result.errors.forEach((item: ErrorData) =>
            enqueueSnackbar(item.message || 'Произошла ошибка', { variant: 'error' })
          );
        });
      }
    },
  });

  return (
    <Button
      variant="secondary"
      leftElement={<DownloadIconComponent />}
      onClick={refetchExportExpendituresToExcel}
      disabled={!isFronting}
    >
      Выгрузить данные
    </Button>
  );
};
